module.exports = __webpack_public_path__ + "img/header-gastronomia.1542ec47.jpg";